/**
 * 「瓦斯」類氣別（可訂購、統一顯示為瓦斯）。
 * 與後端 lpg-app-api quick-order.service.ts 的 GAS_TYPE_VARIANTS 一致；
 * 不在此清單者（如 丙烷／純丙烷）不視為瓦斯，訂購頁應過濾掉。
 */
export const GAS_TYPE_VARIANTS = new Set(["瓦斯", "液化石油氣", "液化氣", "混合氣"]);

/** 是否為可訂購的「瓦斯」氣別（過濾 丙烷／純丙烷 用）。 */
export function isOrderableGasType(gasType: string | null | undefined): boolean {
  return GAS_TYPE_VARIANTS.has((gasType ?? "").trim());
}

/**
 * 訂購頁／Kiosk 對可訂購瓦斯品項一律以「{公斤數}KG 瓦斯」呈現（不顯示實際氣別）。
 * 與訂購頁 GasProductItem 的顯示規則一致；公斤數缺漏時退回「瓦斯」。
 */
export function formatOrderableGasTitle(kilogram: number | string | null | undefined): string {
  const kg = kilogram === null || kilogram === undefined || kilogram === "" ? "" : `${kilogram}KG`;
  return kg ? `${kg} 瓦斯` : "瓦斯";
}

/**
 * 液化氣／丙烷 視為「不顯示氣別字樣」的氣別，只顯示公斤數。
 * 依需求：訂購頁、購物車、結帳/確認頁等任何地方都不顯示「液化氣／丙烷」字樣。
 */
export const HIDDEN_GAS_TYPES = new Set(["液化氣", "液化石油氣", "丙烷", "純丙烷"]);

/**
 * 組合 GAS 商品標題：液化氣／丙烷只顯示公斤數，其餘氣別（如混合氣）維持「氣別 · 公斤數」。
 */
export function formatGasTitle(gasType: string | null | undefined, kilogram: number | string | null | undefined): string {
  const gt = (gasType ?? "").trim();
  const kg = kilogram === null || kilogram === undefined || kilogram === "" ? "" : `${kilogram}KG`;
  const showType = gt && !HIDDEN_GAS_TYPES.has(gt);
  if (showType) return kg ? `${gt} · ${kg}` : gt;
  return kg;
}

/**
 * 取得可顯示的氣別名稱：若為液化氣／丙烷則回傳 fallback（不顯示氣別字樣）。
 */
export function gasTypeDisplayName(gasType: string | null | undefined, fallback: string): string {
  const gt = (gasType ?? "").trim();
  return gt && !HIDDEN_GAS_TYPES.has(gt) ? gt : fallback;
}
